import { css } from 'styled-components';

const styles = {
  label: css`
    position: relative;
    cursor: pointer;
    &:after {
      border-bottom: 1px dashed rgba(39, 45, 45, 0.3);
      content: '';
      height: 1px;
      width: 100%;
      position: absolute;
      left: 50%;
      bottom: 5.5px;
      transform: translateX(-50%);
    }

    &:hover {
      opacity: 0.75;
    }
  `,
  overlayStyle: height => ({
    height,
    border: '1px solid #d7d9de',
    borderRadius: 3,
    overflowY: 'scroll'
  })
};

export default styles;
